export default "__VITE_ASSET__PZf3VuD3__"